import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { object, func, bool } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { isNull, isValidString } from '../../../utils/validator';
import { DatePickerCustom, FormError, FormLabel, Modal } from '../../common';
import TablaItemsGrid from '../TablaItemsGrid';
import {TIPS} from "../../../consts/tips";


const TablaVersionModal = (props) => {

  const entityInit = {
    id: 0,
		idTablaDefinicion: 0,
    numero: '',
    descripcion: '',
    fechaDesde: null,
    fechaHasta: null,
    tablaItems: []
  };

  const [entity, setEntity] = useState(entityInit)

  const [ formValues, formHandle, , formSet ] = useForm({
    numero: '',
    descripcion: '',
    fechaDesde: null,
    fechaHasta: null,
  });

  const mount = () => {
    setEntity(props.data.entity);
    formSet({
      numero: props.data.entity.numero,
      descripcion: props.data.entity.descripcion,
      fechaDesde: props.data.entity.fechaDesde,
      fechaHasta: props.data.entity.fechaHasta
    });
  }
  useEffect(mount, [props.data.entity]);

  const { errorOf, validate } = useFormErrors(getErrors);

  //handles
  const handleClickAceptar = () => {
    if (validate()) {
      if (!isValidString(formValues.numero, true)) {
        ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No se pudo calcular el número de la versión');
        return;
      }

      let row = CloneObject(entity);
      row.numero = formValues.numero;
      row.descripcion = formValues.descripcion;
      row.fechaDesde = formValues.fechaDesde;
      row.fechaHasta = formValues.fechaHasta;

      props.onConfirm(row);
    };
  }
  //funciones
  function getErrors() {
    const errors = {};

    if (!isValidString(formValues.descripcion, true)) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
    if (!props.data.esPrimerVersion && isNull(formValues.fechaDesde)) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;

    return errors;
  }

  const tablaItemsData = useMemo(() => ({
    idTablaDefinicion: entity.idTablaDefinicion,
    idTablaVersion: entity.id,
    columnas: props.data.columnas,
    resultado: props.data.resultado,
    list: entity.tablaItems
  }), [entity, props.data.columnas, props.data.resultado]);

  const updateTablaItem = useCallback((row) => {
    let version = CloneObject(entity);

    if (version.state === 'o') {
        version.state = 'c';
    }
    
    if (row.state === 'a') {
        version.tablaItems.push(row);
    }
    else if (row.state === 'm') {
        const index = version.tablaItems.indexOf(version.tablaItems.find(x => x.id === row.id));
        if (index !== -1) {
            if (row.id < 0) row.state = 'a'; //originalmente era un alta
            version.tablaItems[index] = row;
        }
    }
    else if (row.state === 'r') {
        if (row.id < 0) { //lo elimino directamente porque no existe en la bd
            version.tablaItems = version.tablaItems.filter(f => f.id !== row.id);
        }
        else {
            let item = version.tablaItems.find(x => x.id === row.id);
            item.state = 'r';
        }
    }

    setEntity(version);
  }, [entity]);

  const handleTablaItemChange = useCallback((typeEntity, row) => {
    updateTablaItem(row);
  }, [updateTablaItem]);

  return (
    <>

    <Modal
      size="xl"
      allowFullscreen
      title="Valores"
      tipName={TIPS.NAME.MODALS.VALORES_MODAL}
      onEscape={() => props.onDismiss()}
      body={(<>
            <div className="row">
                <div className="mb-3 col-12 col-md-2">
                    <label htmlFor="numero" className="form-label">Número</label>
                    <input
                      name="numero"
                      type="number"
                      placeholder=""
                      className="form-control"
                      value={formValues.numero}
                      onChange={formHandle}
                      disabled={true}
                    />
                    <FormError />
                </div>
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                    <input
                      name="descripcion"
                      type="text"
                      placeholder=""
                      className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                      value={formValues.descripcion}
                      onChange={formHandle}
                      maxLength={250}
                      disabled={props.disabled}
                    />
                    <FormError message={errorOf('descripcion')} />
                </div>
                <div className="mb-3 col-6 col-md-2">
                    <FormLabel htmlFor="fechaDesde" required={!props.data.esPrimerVersion}>Fecha desde</FormLabel>
                    <DatePickerCustom
                        name="fechaDesde"
                        placeholder=""
                        className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                        value={ formValues.fechaDesde }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('fechaDesde')} />
                </div>
                <div className="mb-3 col-6 col-md-2">
                    <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                    <DatePickerCustom
                        name="fechaHasta"
                        placeholder=""
                        className="form-control"
                        value={ formValues.fechaHasta }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        minValue={formValues.fechaDesde}
                    />
                    <FormError />
                </div>
            </div>
            <div className="row">
                <TablaItemsGrid
                  disabled={props.disabled}
                  data={tablaItemsData}
                  onChange={handleTablaItemChange}
                />
            </div>
      </>)}
      footer={(<>
            <button className={props.onMovePrevious ? "btn btn-i" : "btn btn-i btn-disabled"} data-dismiss="modal" disabled={!props.onMovePrevious}
                    onClick={ (event) => props.onMovePrevious() }>
                <span className="material-symbols-outlined tooltip-container"
                      title='Anterior'>chevron_left</span></button>
            <button className={props.onMoveNext ? "btn btn-i" : "btn btn-i btn-disabled"} data-dismiss="modal" disabled={!props.onMoveNext}
                    onClick={ (event) => props.onMoveNext() }>
                <span className="material-symbols-outlined tooltip-container"
                      title='Siguiente'>chevron_right</span></button>
            {!props.disabled && <>
                <button className="btn btn-primary float-end" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
                <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
            </>}
            {props.disabled &&
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
            }
      </>)}
      footerClassName="modal-footer-unset"
    />

    </>
  );
}

TablaVersionModal.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  onMovePrevious: func,
  onMoveNext: func
};

TablaVersionModal.defaultProps = {
  disabled: false,
  onMovePrevious: null,
  onMoveNext: null
};

export default TablaVersionModal;